import "htmx.org";
import { onDOMReady } from "../utils";

const init = () => {
  const subscriptionPeriodRadios = document.querySelectorAll<HTMLInputElement>("input[name='period']");
  const subscriptionPlanRadios = document.querySelectorAll<HTMLInputElement>("input[name='subscriptionPlan']");

  const selectedPlanName = document.querySelector<HTMLDivElement>("#get-started-plan");
  const selectedPlanSum = document.querySelector<HTMLDivElement>("#get-started-sum");
  const selectedPlanPeriod = document.querySelector<HTMLInputElement>("#get-started-period");

  if (!selectedPlanName || !selectedPlanSum || !selectedPlanPeriod) {
    console.warn("Expected to find #get-started-plan, #get-started-sum and #get-started-period elements on the page but found none.");
  }

  let _period = "monthly";
  let _periodLabel = "monthly";
  let _planName = "free";
  let _planMonthlyPrice = "0";
  let _planYearlyPrice = "0";

  const setValues = () => {
    // console.log("setValues", _period, _periodLabel, _planName, _planMonthlyPrice, _planYearlyPrice);
    selectedPlanName!.textContent = _planName;
    // TODO: Replace hardccoded currency symbol
    selectedPlanSum!.textContent = (_period === "monthly" ? _planMonthlyPrice : _planYearlyPrice) + " $";
    selectedPlanPeriod!.textContent = _periodLabel;
  };

  subscriptionPeriodRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement;
      const periodLabel = target.dataset.periodLabel;
      if (!periodLabel) {
        console.warn("Expected to find data-period-label attribute on the input element but found none.");
        return;
      }
      _period = target.value;
      _periodLabel = periodLabel;
      setValues();
    });
  });

  subscriptionPlanRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const planName = (e.target as HTMLInputElement).dataset.planName;
      const planMonthlyPrice = (e.target as HTMLInputElement).dataset.planMonthlyPrice;
      const planYearlyPrice = (e.target as HTMLInputElement).dataset.planYearlyPrice;
      if (!planName || !planMonthlyPrice || !planYearlyPrice) {
        console.warn(
          "Expected to find data-plan-name, data-plan-monthly-price and data-plan-yearly-price attributes on the input element but found none."
        );
        return;
      }
      _planName = planName;
      _planMonthlyPrice = planMonthlyPrice;
      _planYearlyPrice = planYearlyPrice;
      setValues();
    });
  });

  const setIsLocked = () => {
    const pricingPlansCarousel = document.querySelector<HTMLDivElement>("ui-carousel[name='pricing']");
    if (!pricingPlansCarousel) {
      console.warn("Expected to find carousel[name='pricing'] element on the page but found none.");
      return;
    }

    pricingPlansCarousel.setAttribute("locked", (window.innerWidth < 1280) + "");
  };

  window.addEventListener("resize", () => {
    setIsLocked();
  });

  setIsLocked();
};

onDOMReady(init);

const onLoad = () => {};

window.addEventListener("load", onLoad);
